export function getGetters(state) {
    return {
        referrals: state.referrals,
        loading: state.loading,
        referralsSelected: state.referralsSelected,
        exportData: state.exportData,
        referralsSearch: state.referralsSearch,
    }
}